import React from 'react'
import './contact.css'
import {MdEmail} from 'react-icons/md'
import {SiMinutemailer} from 'react-icons/si'

const contact = () => {
  return (
    <section id='contact'>
      <h5>How To Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className='container contact__container'>
        <div className='contact_options'>
          <article className='contact__option'>
            <MdEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>nikoboykin@gmai.com</h5>
            <a href="mailto:nikoboykin@gmail.com" target='__blank'>Send a message<SiMinutemailer /></a>
          </article>
        </div>
        {/* END OF CONTACT OPTIONS */}
        <form action="">
          <input type="text" name='name' placeholder='Your Full Name' required/>
          <input type="text" name='email' placeholder='Your Email' required />
          <textarea name="message" id="7" cols="30" rows="10" placeholder='Enter Your Message'></textarea>
          <button type='submit' className='btn btn-primary'>Send Message<SiMinutemailer /></button>
        </form>

      </div>
    </section>
  )
}

export default contact